export default __webpack_public_path__ + "04b1bb28197c64937b19b057ec5d8797.png";